import { _ep0, _mw11, command } from "../commandBuilder";
import { PutObject$ } from "../schemas/schemas_0";
export class PutObjectCommand extends command(_ep0, _mw11, "PutObject", PutObject$) {
}
